import React from 'react';

import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';

import { Button, Header, Icon, Modal, Table, Message, Label } from 'semantic-ui-react';
import { HorizontalBar } from 'react-chartjs-2';

const cf = num => numeral(num).format('0,0');
const pf = num => numeral(num).format('0.0%');
const df = num => numeral(num).format('0.0');

const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const barOptions = {
  tooltips: {
    mode: 'index',
    intersect: false,
  },
  responsive: true,
  showScale: false,
  scales: {
    xAxes: [{
      stacked: true,
    }],
    yAxes: [{
      stacked: true,
    }],
  },
};

const fbH4 = {
  padding: 5,
  border: '1px solid #ccc',
  backgroundColor: '#eee',
};

const getDemographics = (data, gender) => {
  if (!data) return null;

  const labels = ['age13-17', 'age18-24', 'age25-34', 'age35-44', 'age45-54', 'age55-64', 'age65-'];
  const demos = _.map(labels, label => {
    const dp = _.find(data, d => {
      if (d[0] === gender && d[1] === label) {
        return d ? d[2] : 0;
      }
    });
    return dp;
  });

  const xxx = _.map(demos, d => (d ? d[2] : 0));
  return xxx;
};

const YoutubeInsightsModal = ({ latestStatistic, popupToggleHandler, open }) => {
  if (!latestStatistic) return null;
  const { insights } = latestStatistic;
  if (!open) return null;

  const collectedDate = moment(latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');

  const headers = [
    'Country',
    'Views',
    'Mins Watched',
    'Likes',
    'Comments',
    'Dislikes',
    'Shares',
    'Subs +',
    'Subs -',
  ];

  const top10Countries = _.take(insights.viewingByCountry, 10);
  const demoPercentages = insights.audienceDemographics;

  const barData = {
    labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
    datasets: [
      {
        label: 'male %',
        backgroundColor: dyzioPalette.blue,
        borderColor: dyzioPalette.bgBlue,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'male'),
      },
      {
        label: 'female %',
        backgroundColor: dyzioPalette.bgPink,
        borderColor: dyzioPalette.pink,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'female'),
      },
    ],
  };

  return (
    <Modal
      open={open}
      onClose={popupToggleHandler}
      size="small"
    >
      <Header icon="pie graph" content="Youtube Video Insights" />
      <Modal.Content>
        <h4 style={fbH4}>Viewing by Country (Top 10)</h4>
        <Table basic="very" celled fluid small textAlign="center" style={{ padding: 5 }}>
          <Table.Body>
            <Table.Row>
              { _.map(headers, m => (
                <Table.HeaderCell>
                  { m }
                </Table.HeaderCell>
              ))
              }
            </Table.Row>

            { _.map(top10Countries, c => (
              <Table.Row>

                { _.map(headers, (m, idx) => (
                  <Table.Cell>
                    { idx === 0 ? <b>{ c[idx] }</b> : cf(c[idx]) }
                  </Table.Cell>
                ))
                }
              </Table.Row>
            ))}

          </Table.Body>
        </Table>

        <h4 style={fbH4}>Audience Demographics</h4>
        {
          demoPercentages
            ? <HorizontalBar data={barData} options={barOptions} />
            : <Message warning>
              <Message.Header>Insufficent Data!</Message.Header>
              <p>Youtube did not provide enough data for the audience demographics report.</p>
            </Message>
        }

        <br />
        <p className="centered">
          <Label centered icon="clock" color="grey" basic content={`data collected ${collectedDate}`} />
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="green" onClick={popupToggleHandler} inverted>
          <Icon name="checkmark" /> Got it
        </Button>
      </Modal.Actions>
    </Modal>
  );
};


export default YoutubeInsightsModal;



/** WEBPACK FOOTER **
 ** ./src/components/youtube-insights-modal/index.js
 **/